import React from 'react';
import styled from '@emotion/styled';
import { InformationIcon } from '@warbyparker/retail-design-system';

const BannerContainer = styled.div`
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  padding: 16px 24px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 16px auto;
  max-width: 720px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const IconWrapper = styled.div`
  flex-shrink: 0;
  color: #856404;
  display: flex;
  align-items: center;
  padding-top: 2px;
`;

const Content = styled.div`
  flex: 1;
  color: #856404;
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
`;

const Message = styled.div`
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 12px;
`;

const Link = styled.a`
  color: #0056b3;
  text-decoration: underline;
  font-weight: 500;

  &:hover {
    color: #003d82;
  }
`;

const DecommissionBanner: React.FC = () => (
  <BannerContainer role="alert" aria-live="polite">
    <IconWrapper>
      <InformationIcon />
    </IconWrapper>
    <Content>
      <Title>Important: Service Decommission Notice</Title>
      <Message>
        RxEntry will be decommissioned on 6/5. All users will no longer have access.
        Please go to PoP to issue prescriptions.
      </Message>
      <Link
        href="https://pmp.warbyparker.com/appointments"
        target="_blank"
        rel="noopener noreferrer"
      >
        Go to PoP →
      </Link>
    </Content>
  </BannerContainer>
);

export default DecommissionBanner;
